import { TextField } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const IncrementInputContainer = styled.div`
    display: flex;
    margin: ${getPurpurSpacing('200')} 0;
    align-items: center;
    font-size: 1rem;
`;

export const NumberInput = styled(TextField)`
    margin: 0 10px;
    width: 100%;
    text-align: center;
    position: relative;

    input {
        text-align: center;
        margin-top: 1px;
        -moz-appearance: textfield;
    }
    input::-webkit-inner-spin-button,
    input::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
        width: 1rem;
    }
` as typeof TextField;

export const NumberInputPostfixSign = styled.span`
    position: absolute;
    right: ${getPurpurSpacing('150')};
    top: ${getPurpurSpacing('150')};
`;
